import { lazy, type ComponentType } from 'react'

// Lazy-loaded page components for rendering inside virtual windows.
// These are the same components used in App.tsx routes.
const AccountsPage = lazy(() => import('@/pages/AccountsPage').then(m => ({ default: m.AccountsPage })))
const JournalEntriesPage = lazy(() => import('@/pages/JournalEntriesPage').then(m => ({ default: m.JournalEntriesPage })))
const NewJournalEntryPage = lazy(() => import('@/pages/NewJournalEntryPage').then(m => ({ default: m.NewJournalEntryPage })))
const InvoicesPage = lazy(() => import('@/pages/InvoicesPage').then(m => ({ default: m.InvoicesPage })))
const QuotesPage = lazy(() => import('@/pages/QuotesPage').then(m => ({ default: m.QuotesPage })))
const CreditNotesPage = lazy(() => import('@/pages/CreditNotesPage').then(m => ({ default: m.CreditNotesPage })))
const ContactsPage = lazy(() => import('@/pages/ContactsPage').then(m => ({ default: m.ContactsPage })))
const BankingPage = lazy(() => import('@/pages/BankingPage').then(m => ({ default: m.BankingPage })))
const InventoryPage = lazy(() => import('@/pages/InventoryPage').then(m => ({ default: m.InventoryPage })))
const PurchaseOrdersPage = lazy(() => import('@/pages/PurchaseOrdersPage').then(m => ({ default: m.PurchaseOrdersPage })))
const TimesheetPage = lazy(() => import('@/pages/TimesheetPage').then(m => ({ default: m.TimesheetPage })))
const ExpenseClaimsPage = lazy(() => import('@/pages/ExpenseClaimsPage').then(m => ({ default: m.ExpenseClaimsPage })))
const ReportsPage = lazy(() => import('@/pages/ReportsPage').then(m => ({ default: m.ReportsPage })))
const JobsPage = lazy(() => import('@/pages/JobsPage').then(m => ({ default: m.JobsPage })))
const FixedAssetsPage = lazy(() => import('@/pages/FixedAssetsPage').then(m => ({ default: m.FixedAssetsPage })))
const TeamPage = lazy(() => import('@/pages/TeamPage').then(m => ({ default: m.TeamPage })))
const AdminPage = lazy(() => import('@/pages/AdminPage').then(m => ({ default: m.AdminPage })))
const BillingPage = lazy(() => import('@/pages/BillingPage').then(m => ({ default: m.BillingPage })))
const UtilitiesPage = lazy(() => import('@/pages/UtilitiesPage').then(m => ({ default: m.UtilitiesPage })))
const BillComparisonPage = lazy(() => import('@/pages/BillComparisonPage').then(m => ({ default: m.BillComparisonPage })))
const SiteAdminPage = lazy(() => import('@/pages/SiteAdminPage').then(m => ({ default: m.SiteAdminPage })))

// Maps route strings to lazy-loaded page components
export const WINDOW_ROUTES: Record<string, ComponentType> = {
  '/accounts': AccountsPage,
  '/journal-entries': JournalEntriesPage,
  '/journal-entries/new': NewJournalEntryPage,
  '/invoices': InvoicesPage,
  '/quotes': QuotesPage,
  '/credit-notes': CreditNotesPage,
  '/contacts': ContactsPage,
  '/banking': BankingPage,
  '/inventory': InventoryPage,
  '/purchase-orders': PurchaseOrdersPage,
  '/time-tracking': TimesheetPage,
  '/expense-claims': ExpenseClaimsPage,
  '/reports': ReportsPage,
  '/jobs': JobsPage,
  '/fixed-assets': FixedAssetsPage,
  '/team': TeamPage,
  '/admin': AdminPage,
  '/billing': BillingPage,
  '/utilities': UtilitiesPage,
  '/bill-comparison': BillComparisonPage,
  '/site-admin': SiteAdminPage,
}

// Find the best matching component for a given route (prefix match)
export function resolveWindowComponent(route: string): ComponentType | null {
  // Exact match first
  if (WINDOW_ROUTES[route]) return WINDOW_ROUTES[route]
  // Prefix match (e.g., /accounts/123 → /accounts)
  const base = route.split('?')[0]
  for (const [pattern, component] of Object.entries(WINDOW_ROUTES)) {
    if (base.startsWith(pattern + '/') || base === pattern) return component
  }
  return null
}
